module.exports = __webpack_public_path__ + "img/Inside-sp_11.62507a56.jpg";